export const inProgressPayload = {
  carrierCode: 'Purolator',
  serviceLevel: 'CanparGround',
  shipDate: '2025-02-24',
  saturdayDelivery: false,
  documentsOnly: false,
  fromAddress: {
    company: 'My company',
    contact: 'Shamim Hossain',
    phone: '+30980298430',
    addr1: '1000 Airport Parkway Private',
    countryCode: 'CA',
    postalCode: 'K1V9B4',
    city: 'OTTAWA',
    province: 'ON',
    residential: false,
    emails: [
      'shossain@secureship.ca',
    ],
    isInside: false,
    isTailGate: false,
    isTradeShow: true,
    isLimitedAccess: false,
    isSaturday: false,
    isStopinOnly: false,
  },
  toAddress: {
    company: 'Khaled',
    contact: 'Khaled',
    phone: '+30980298430',
    addr1: '1st main sterrt',
    countryCode: 'CA',
    postalCode: 'K1K1K1',
    city: 'OTTAWA',
    province: 'ON',
    residential: false,
    emails: [],
    isInside: false,
    isTailGate: false,
    isTradeShow: false,
    isLimitedAccess: false,
    isSaturday: false,
    isStopinOnly: false,
  },
  emailNotifications: [
    {
      email: {},
      delivery: true,
      exception: false,
      ship: false,
    },
  ],
  references: [
    'ref',
  ],
  billing: {
    billingType: 'Prepaid',
  },
  useSecureship: true,
  temporaryPackage: {
    packageType: 'MyPackage',
    weight: 0,
    weightUnits: 'Lbs',
    length: 0,
    width: 0,
    height: 0,
    dimUnits: 'Inches',
    insurance: 0,
    isAdditionalHandling: false,
    temperatureProtection: false,
  },
  packages: [
    {
      packageType: 'MyPackage',
      weight: 12,
      weightUnits: 'Lbs',
      length: 12,
      width: 12,
      height: 12,
      dimUnits: 'Inches',
      insurance: 0,
      isAdditionalHandling: false,
      signatureOptions: 'None',
      temperatureProtection: false,
      isDangerousGoods: false,
      isNonStackable: false,
    },
    {
      packageType: 'MyPackage',
      weight: 12,
      weightUnits: 'Lbs',
      length: 12,
      width: 12,
      height: 12,
      dimUnits: 'Inches',
      insurance: 0,
      isAdditionalHandling: false,
      signatureOptions: 'None',
      temperatureProtection: false,
      isDangerousGoods: false,
      isNonStackable: false,
    },
  ],
  ecommerce: {
    platformType: 'Undefined',
    shopDetails: {},
    fulfillOrder: false,
    storeNotification: false,
  },
  signatureOptions: 'None',
  comments: null,
};

export const inProgressPayloadAfterServiceSelected = {
  carrierCode: 'Purolator',
  serviceLevel: 'CanparGround',
  shipDate: '2025-02-24',
  saturdayDelivery: false,
  documentsOnly: false,
  fromAddress: {
    company: 'My company',
    contact: 'Shamim Hossain',
    phone: '+30980298430',
    addr1: '1000 Airport Parkway Private',
    countryCode: 'CA',
    postalCode: 'K1V9B4',
    city: 'OTTAWA',
    province: 'ON',
    residential: false,
    emails: [
      'shossain@secureship.ca',
    ],
    isInside: false,
    isTailGate: false,
    isTradeShow: true,
    isLimitedAccess: false,
    isSaturday: false,
    isStopinOnly: false,
  },
  toAddress: {
    company: 'Khaled',
    contact: 'Khaled',
    phone: '+30980298430',
    addr1: '1st main sterrt',
    countryCode: 'CA',
    postalCode: 'K1K1K1',
    city: 'OTTAWA',
    province: 'ON',
    residential: false,
    emails: [],
    isInside: false,
    isTailGate: false,
    isTradeShow: false,
    isLimitedAccess: false,
    isSaturday: false,
    isStopinOnly: false,
  },
  emailNotifications: [
    {
      email: {},
      delivery: true,
      exception: false,
      ship: false,
    },
  ],
  references: [
    'ref',
  ],
  billing: {
    billingType: 'Prepaid',
  },
  useSecureship: true,
  temporaryPackage: {
    packageType: 'MyPackage',
    weight: 0,
    weightUnits: 'Lbs',
    length: 0,
    width: 0,
    height: 0,
    dimUnits: 'Inches',
    insurance: 0,
    isAdditionalHandling: false,
    temperatureProtection: false,
  },
  packages: [
    {
      packageType: 'MyPackage',
      weight: 12,
      weightUnits: 'Lbs',
      length: 12,
      width: 12,
      height: 12,
      dimUnits: 'Inches',
      insurance: 0,
      isAdditionalHandling: false,
      signatureOptions: 'None',
      temperatureProtection: false,
      isDangerousGoods: false,
      isNonStackable: false,
    },
    {
      packageType: 'MyPackage',
      weight: 12,
      weightUnits: 'Lbs',
      length: 12,
      width: 12,
      height: 12,
      dimUnits: 'Inches',
      insurance: 0,
      isAdditionalHandling: false,
      signatureOptions: 'None',
      temperatureProtection: false,
      isDangerousGoods: false,
      isNonStackable: false,
    },
  ],
  ecommerce: {
    platformType: 'Undefined',
    shopDetails: {},
    fulfillOrder: false,
    storeNotification: false,
  },
  signatureOptions: 'None',
  comments: null,
};

export const ratesPayload = {
  currencyCode: 'CAD',
  fromAddress: {
    company: 'My company',
    contact: 'Shamim Hossain',
    phone: '+30980298430',
    addr1: '1000 Airport Parkway Private',
    countryCode: 'CA',
    postalCode: 'K1V9B4',
    city: 'OTTAWA',
    province: 'ON',
    residential: false,
    emails: [
      'shossain@secureship.ca',
    ],
    isInside: false,
    isTailGate: false,
    isTradeShow: true,
    isLimitedAccess: false,
    isSaturday: false,
    isStopinOnly: false,
  },
  toAddress: {
    company: 'Khaled',
    contact: 'Khaled',
    phone: '+30980298430',
    addr1: '1st main sterrt',
    countryCode: 'CA',
    postalCode: 'K1K1K1',
    city: 'OTTAWA',
    province: 'ON',
    residential: false,
    emails: [],
    isInside: false,
    isTailGate: false,
    isTradeShow: false,
    isLimitedAccess: false,
    isSaturday: false,
    isStopinOnly: false,
  },
  packages: [
    {
      packageType: 'MyPackage',
      weight: 12,
      weightUnits: 'Lbs',
      length: 12,
      width: 12,
      height: 12,
      dimUnits: 'Inches',
      insurance: 0,
      isAdditionalHandling: false,
      signatureOptions: 'None',
      temperatureProtection: false,
      isDangerousGoods: false,
      isNonStackable: false,
    },
    {
      packageType: 'MyPackage',
      weight: 12,
      weightUnits: 'Lbs',
      length: 12,
      width: 12,
      height: 12,
      dimUnits: 'Inches',
      insurance: 0,
      isAdditionalHandling: false,
      signatureOptions: 'None',
      temperatureProtection: false,
      isDangerousGoods: false,
      isNonStackable: false,
    },
  ],
  shipDateTime: '2025-02-24',
  documentsOnly: false,
};

export const ratesPayloadForReturn = {
  currencyCode: 'CAD',
  fromAddress: {
    company: 'Khaled',
    contact: 'Khaled',
    phone: '+30980298432',
    addr1: '1st main sterrt',
    addr2: '',
    addr3: '',
    countryCode: 'CA',
    postalCode: 'K1K1K1',
    city: 'OTTAWA',
    province: 'ON',
    residential: false,
    taxId: '',
    emails: [],
    isInside: false,
    isTailGate: false,
    isTradeShow: false,
    isLimitedAccess: false,
    isSaturday: false,
    isStopinOnly: false,
  },
  toAddress: {
    company: 'My company',
    contact: 'Shamim Hossain',
    phone: '+30980298430',
    addr1: '1000 Airport Parkway Private',
    addr2: '',
    countryCode: 'CA',
    postalCode: 'K1V9B4',
    city: 'OTTAWA',
    province: 'ON',
    residential: false,
    taxId: '',
    emails: [
      'shossain@secureship.ca',
    ],
    isInside: false,
    isTailGate: false,
    isTradeShow: true,
    isLimitedAccess: false,
    isSaturday: false,
    isStopinOnly: false,
  },
  packages: [
    {
      packageType: 'MyPackage',
      weight: 12,
      length: 12,
      width: 12,
      height: 12,
      dimUnits: 'Inches',
      weightUnits: 'Lbs',
      insurance: 0,
      isAdditionalHandling: false,
      signatureOptions: 'None',
      shipStatus: 'Created',
      lastScan: 'Shipment Created',
      carrierTrackingNumber: 'D999999920000139000001',
    },
    {
      packageType: 'MyPackage',
      weight: 12,
      length: 12,
      width: 12,
      height: 12,
      dimUnits: 'Inches',
      weightUnits: 'Lbs',
      insurance: 0,
      isAdditionalHandling: false,
      signatureOptions: 'None',
      shipStatus: 'Created',
      lastScan: 'Shipment Created',
      carrierTrackingNumber: 'D999999920000139000002',
    },
  ],
  shipDateTime: '2025-02-24T00:00:00',
  documentsOnly: false,
};

export const createLabelPayload = {
  selectedService: 'CanparGround',
  fromAddress: {
    company: 'My company',
    contact: 'Shamim Hossain',
    phone: '+30980298430',
    addr1: '1000 Airport Parkway Private',
    countryCode: 'CA',
    postalCode: 'K1V9B4',
    city: 'OTTAWA',
    province: 'ON',
    residential: false,
    emails: [
      'shossain@secureship.ca',
    ],
    isInside: false,
    isTailGate: false,
    isTradeShow: true,
    isLimitedAccess: false,
    isSaturday: false,
    isStopinOnly: false,
  },
  toAddress: {
    company: 'Khaled',
    contact: 'Khaled',
    phone: '+30980298432',
    addr1: '1st main sterrt',
    countryCode: 'CA',
    postalCode: 'K1K1K1',
    city: 'OTTAWA',
    province: 'ON',
    residential: false,
    emails: [],
    isInside: false,
    isTailGate: false,
    isTradeShow: false,
    isLimitedAccess: false,
    isSaturday: false,
    isStopinOnly: false,
  },
  packages: [
    {
      packageType: 'MyPackage',
      weight: 12,
      weightUnits: 'Lbs',
      length: 12,
      width: 12,
      height: 12,
      dimUnits: 'Inches',
      insurance: 0,
      isAdditionalHandling: false,
      signatureOptions: 'None',
      temperatureProtection: false,
      isDangerousGoods: false,
      isNonStackable: false,
    },
    {
      packageType: 'MyPackage',
      weight: 12,
      weightUnits: 'Lbs',
      length: 12,
      width: 12,
      height: 12,
      dimUnits: 'Inches',
      insurance: 0,
      isAdditionalHandling: false,
      signatureOptions: 'None',
      temperatureProtection: false,
      isDangerousGoods: false,
      isNonStackable: false,
    },
  ],
  shipDateTime: '2025-02-24T00:00:00.000Z',
  deliveryEmails: [],
  billingOption: 'Prepaid',
  documentsOnly: false,
  ecommerce: {
    platformType: 'Undefined',
    shopDetails: {},
    fulfillOrder: false,
    storeNotification: false,
  },
  references: [
    'ref',
  ],
  comments: '',
  clearInProgress: true,
};

export const secureshipTrackingNo = '330118TBPR4026829';
